export const noop = () => {};
export const sleepFor = (time: number, kind: 's' | 'mi' = 's') =>
  new Promise<void>((resolve) => setTimeout(resolve, kind === 'mi' ? time : time * 1000));

export const callIgnoreError = <T extends () => unknown>(c: T): ReturnType<T> | undefined => {
  try {
    return c?.() as ReturnType<T>;
  } catch {
    /* ignore the error */
  }
};

export function filterObject<T>(obj: T, filterFn: (v: unknown, obj: T) => unknown = (v) => v != null): T {
  return Object.fromEntries(Object.entries(obj as unknown as object).filter(([, v]) => filterFn(v, obj))) as T;
}
